import { isArray } from 'lodash'
import { useSprintsStore } from 'src/stores/index.js'

export default {
  filteredSprints (state) {
    const sprintsStore = useSprintsStore()
    if (state.galeryQuery.type === 'forms') return []

    return sprintsStore.missionSprints.filter(sprint => {
      // Validate sprint
      if (state.galeryQuery.sprint && state.galeryQuery.sprint?.id !== sprint.id) return false

      const locationsId = JSON.parse(sprint.locations_id)
      const queryLocations = state.galeryQuery.locationsIds
      // Validate locationsIds
      if (queryLocations.length > 0 && sprint.locations_id && !queryLocations.some(id => locationsId.includes(id))) {
        return false
      }
      // Validate startDate and endDate
      if (state.galeryQuery.startDate || state.galeryQuery.endDate) {
        const startDate = state.galeryQuery.startDate ? new Date(state.galeryQuery.startDate) : null
        const endDate = state.galeryQuery.endDate ? new Date(state.galeryQuery.endDate) : null
        const sprintStartDate = new Date(sprint.start_date)
        const sprintEndDate = new Date(sprint.end_date)

        if (startDate && sprintStartDate < startDate) return false
        if (endDate && sprintEndDate > endDate) return false
      }
      // Validate roleId
      if (state.galeryQuery.roleId && state.galeryQuery.roleId !== Number(sprint.role_id)) {
        return false
      }

      // Validate usersIds
      if (
          state.galeryQuery.usersIds.length > 0 && sprint.assigned_to
          && !state.galeryQuery.usersIds.some(id => JSON.parse(sprint.assigned_to).includes(id))
        ) {
        return false
      }
      return true
    })
  },
  filteredForms (state) {
    if (!state || !isArray(state.recentForms)) return []

    return state.recentForms.filter(form => {
      const queryLocations = state.galeryQuery.locationsIds

      // Validate locationsIds
      if (queryLocations.length > 0 && !queryLocations.some(id => form.locations.includes(id))) {
        return false
      }
      return true
    })
  }
}
